import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { recipePhotosQuery } from '@/api'
import { Button } from '@/components/Button'
import { PageEditHeader } from '@/components/PageEditHeader'
import PhotosView from '@/features/recipes/PhotosView'
import GenerateImageModal from '@/features/recipes/PhotosView/GenerateImageModal'

export const Route = createFileRoute('/recipes_/$recipeId_/photos')({
  component: RouteComponent,
  validateSearch: (params: Record<string, unknown>): { recipeId?: string } => {
    return {
      recipeId: params.recipeId as string,
    }
  },
  loader: async ({ context: { queryClient }, params }) => {
    const idRecipe = parseInt(params.recipeId)
    const photos = await queryClient.ensureQueryData(recipePhotosQuery(idRecipe))

    return { photos, idRecipe }
  },
})

function RouteComponent() {
  const { t } = useTranslation()
  const { idRecipe } = Route.useLoaderData()
  const { data: photos } = useSuspenseQuery(recipePhotosQuery(idRecipe))
  const [isModalOpen, setIsModalOpen] = useState(false)

  return (
    <>
      <PageEditHeader title={t('photos.title')}>
        <Button variant="primary" onPress={() => setIsModalOpen(true)}>
          {t('photos.generateAIImage')}
        </Button>
      </PageEditHeader>

      <PhotosView photos={photos} idRecipe={idRecipe} />

      <GenerateImageModal isOpen={isModalOpen} setOpen={setIsModalOpen} idRecipe={idRecipe} />
    </>
  )
}
